/* eslint-disable max-len */
import * as React from 'react';

const SkipArrow = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.23657 15.7708C8.92114 15.4652 8.92114 14.9696 9.23657 14.664L14.0501 10L9.23657 5.336C8.92114 5.03037 8.92114 4.53485 9.23657 4.22922C9.55199 3.92359 10.0634 3.92359 10.3788 4.22922L15.7634 9.44661C16.0789 9.75224 16.0789 10.2478 15.7634 10.5534L10.3788 15.7708C10.0634 16.0764 9.55199 16.0764 9.23657 15.7708Z"
      fill="#121212"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.23657 15.7708C3.92114 15.4652 3.92114 14.9696 4.23657 14.664L9.05006 10L4.23657 5.336C3.92114 5.03037 3.92114 4.53485 4.23657 4.22922C4.55199 3.92359 5.06339 3.92359 5.37882 4.22922L10.7634 9.44661C11.0789 9.75224 11.0789 10.2478 10.7634 10.5534L5.37882 15.7708C5.06339 16.0764 4.55199 16.0764 4.23657 15.7708Z"
      fill="#121212"
    />
  </svg>
);
export default SkipArrow;
